import { render } from "./DownloadData.vue?vue&type=template&id=213d9c15"
import script from "./DownloadData.vue?vue&type=script&lang=js"
export * from "./DownloadData.vue?vue&type=script&lang=js"

import "./DownloadData.vue?vue&type=style&index=0&id=213d9c15&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__